"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArtSetSku = exports.getArtworkSku = exports.getArtworkName = void 0;
function getFormattedSizeSpecification({ sizeSpecification }) {
    if (!sizeSpecification) {
        return null;
    }
    const splitSizeSpecification = sizeSpecification.split('_');
    return splitSizeSpecification.length === 2 ? splitSizeSpecification[1] : null;
}
function getSizeSpecificationText({ sizeSpecification, separatorText }) {
    const formattedSize = getFormattedSizeSpecification({ sizeSpecification });
    return formattedSize ? `${separatorText}${formattedSize}` : '';
}
function getArtworkName({ artwork, sizeSpecification }) {
    return `${artwork.title} by ${artwork.artistName}` + getSizeSpecificationText({
        sizeSpecification,
        separatorText: ' - '
    });
}
exports.getArtworkName = getArtworkName;
function getArtworkSku({ artwork, sizeSpecification }) {
    return `ART_ARTPIECE_${artwork.id}` + getSizeSpecificationText({ sizeSpecification, separatorText: '_' });
}
exports.getArtworkSku = getArtworkSku;
function getArtSetSku({ artset, sizeSpecification }) {
    return `ART_GALLERYWALL_${artset.id}` + getSizeSpecificationText({ sizeSpecification, separatorText: '_' });
}
exports.getArtSetSku = getArtSetSku;
//# sourceMappingURL=googleMarketingMarkup.js.map